import { createContext } from 'react';

/**
 * Quem está na sessão do portal: o id da pessoa (o `/eu`), ou null quando o id não vem — nunca o e-mail, que no nome da
 * chave do aparelho seria dado pessoal guardado à toa (LGPD). Serve para separar, no aparelho compartilhado, os ajustes de
 * tela de cada um (a escala dos gráficos e o 3D do CPTu, onda 347, spec §4.8); sem quem, os ajustes valem até sair da
 * tela e nada se guarda.
 */
export const QuemEsta = createContext<string | null>(null);
